export default /*@ngInject*/ function (ViewProductImportPageService) {
    const vm = this;

    vm.$onInit = init;

    vm.ViewProductImportPageService = ViewProductImportPageService;
    vm.updateNSRoleDropdown = updateNSRoleDropdown;
    vm.getImportStatusClass = getImportStatusClass;

    function init() {
        vm.uploadOnlyProducts = ["OREPM", "SAPB1", "Zuo", "CNC"];
    }

    function updateNSRoleDropdown(configChanged) {
        vm.nsRolesChanged = configChanged;
    }

    function getImportStatusClass(status) {
        const classes = {
            "Completed": "toast-success",
            "InProgress": "toast-loading",
            "Error": "toast-error",
            "Skipped": "toast-warning"
        }

        return classes[status];
    }
}